module.exports = __webpack_public_path__ + "static/media/027.08c608a9.jpg";